export default "__VITE_ASSET__B$4j3lKk__"